import { Reportv2Component } from './reportv2.component';
import { AuthGuard } from '../../../../common/services/Auth.guard';

export const ReportRoutev2 = [
  {
    path: 'report',
    component: Reportv2Component,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'summary', pathMatch: 'full' },
      {
        path: 'summary',
        component: Reportv2Component,
        canActivate: [AuthGuard],
      },
      {
        path: 'ticket',
        component: Reportv2Component,
        canActivate: [AuthGuard],
        data: { role: ['administrator', 'supervisor', 'team_leader'] },
      },
      {
        path: 'agent',
        component: Reportv2Component,
        canActivate: [AuthGuard],
        data: { role: ['administrator', 'supervisor', 'team_leader'] },
      },
      {
        path: 'customer',
        component: Reportv2Component,
        canActivate: [AuthGuard],
        data: { role: ['administrator', 'supervisor', 'team_leader'] },
      },
      {
        path: 'history',
        component: Reportv2Component,
        canActivate: [AuthGuard],
      },
      {
        path: 'customs',
        component: Reportv2Component,
        canActivate: [AuthGuard],
        data: { role: ['administrator', 'supervisor', 'team_leader'] },
      },
      {
        path: 'group',
        component: Reportv2Component,
        canActivate: [AuthGuard],
        data: { role: ['administrator', 'supervisor', 'team_leader'] },
      },
      // { path: 'agentv1', component: Reportv2Component, canActivate: [AuthGuard] ,data: {role: ['administrator', 'supervisor', 'team_leader']} },
      // { path: 'channels', component: Reportv2Component, canActivate: [AuthGuard] },
      // { path: 'agents', component: Reportv2Component, canActivate: [AuthGuard] },
      // { path: 'call-monitor', component: Reportv2Component, canActivate: [AuthGuard] },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/reportv2/reportv2.route.ts